module.exports = __webpack_public_path__ + "img/pop_close.02084cf1.png";